/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuFilterStone_itemSearch = {
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuMultiSelectSearch_itemSearch">;
    readonly " $refType": "SbSharedRefineMenuFilterStone_itemSearch";
};
export type SbSharedRefineMenuFilterStone_itemSearch$data = SbSharedRefineMenuFilterStone_itemSearch;
export type SbSharedRefineMenuFilterStone_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuFilterStone_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuFilterStone_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuFilterStone_itemSearch",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectSearch_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '81fc1403c4474ba95e83c72409ee2007';
export default node;
